module.exports = __webpack_public_path__ + "img/img_preferencias.52c27820.jpg";